/* eslint-disable */
/* tslint:disable */

/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
import {
  ServiceType,
  InboundType,
  InboundInsuranceOnDateOfService,
  Benefit,
  NjmmisCheckStatus,
} from './globalTypes' // ====================================================
// GraphQL query operation: Inbounds
// ====================================================

import {InboundsVariables as InboundsVariablesOrig} from '../types/Inbounds'
import {Inbounds as InboundsOrig} from '../types/Inbounds'
import {Inbounds_inbounds as Inbounds_inboundsOrig} from '../types/Inbounds'
import {Inbounds_inbounds_account as Inbounds_inbounds_accountOrig} from '../types/Inbounds'
import {Inbounds_inbounds_mostRecentNjmmisCheck as Inbounds_inbounds_mostRecentNjmmisCheckOrig} from '../types/Inbounds'
import {Inbounds_inbounds_personFormData as Inbounds_inbounds_personFormDataOrig} from '../types/Inbounds'
import {Inbounds_inbounds_person as Inbounds_inbounds_personOrig} from '../types/Inbounds'
import {AdditionalData} from 'utils/getAdditionalData'
import {parseAdditionalData} from 'utils/getAdditionalData'
import {serializeAdditionalData} from 'utils/getAdditionalData'
import formatISO from 'date-fns/formatISO'
import {parseDate} from 'utils/form/fieldTypes'
import {formatISODate} from 'utils/date'
import {Inbounds_inbounds_person_mostRecentEligibilityDeterminations as Inbounds_inbounds_person_mostRecentEligibilityDeterminationsOrig} from '../types/Inbounds'
import {BenefitType} from 'utils/benefits'
import {deserializeBenefit} from 'graphql/converters'
import {serializeBenefit} from 'graphql/converters'
import {Inbounds_inbounds_person_openApplications as Inbounds_inbounds_person_openApplicationsOrig} from '../types/Inbounds'
import {Inbounds_inbounds_completedBy as Inbounds_inbounds_completedByOrig} from '../types/Inbounds'
import {Inbounds_inbounds_startedBy as Inbounds_inbounds_startedByOrig} from '../types/Inbounds'
export interface Inbounds_inbounds_startedBy {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializeInbounds_inbounds_startedBy = (
  serialized: Inbounds_inbounds_startedByOrig
): Inbounds_inbounds_startedBy => ({...serialized})
export const serializeInbounds_inbounds_startedBy = (
  deserialized: Inbounds_inbounds_startedBy
): Inbounds_inbounds_startedByOrig => ({...deserialized})
export interface Inbounds_inbounds_completedBy {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializeInbounds_inbounds_completedBy = (
  serialized: Inbounds_inbounds_completedByOrig
): Inbounds_inbounds_completedBy => ({...serialized})
export const serializeInbounds_inbounds_completedBy = (
  deserialized: Inbounds_inbounds_completedBy
): Inbounds_inbounds_completedByOrig => ({...deserialized})
export interface Inbounds_inbounds_person_openApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeInbounds_inbounds_person_openApplications = (
  serialized: Inbounds_inbounds_person_openApplicationsOrig
): Inbounds_inbounds_person_openApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeInbounds_inbounds_person_openApplications = (
  deserialized: Inbounds_inbounds_person_openApplications
): Inbounds_inbounds_person_openApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Inbounds_inbounds_person_mostRecentEligibilityDeterminations {
  __typename: 'EligibilityDetermination'
  id: string
  benefit: string
  status: string
  reasonOrInfo: string | null
  secondaryInfo: string | null
  householdSizeDescription: string | null
  month: Date | null
  numMonths: number | null
  createdAt: Date
  additionalData: AdditionalData | null
}
export const deserializeInbounds_inbounds_person_mostRecentEligibilityDeterminations = (
  serialized: Inbounds_inbounds_person_mostRecentEligibilityDeterminationsOrig
): Inbounds_inbounds_person_mostRecentEligibilityDeterminations => ({
  ...serialized,
  month:
    serialized.month != null ? parseDate(serialized.month) : serialized.month,
  createdAt: parseDate(serialized.createdAt),
  additionalData:
    serialized.additionalData != null
      ? parseAdditionalData(serialized.additionalData)
      : serialized.additionalData,
})
export const serializeInbounds_inbounds_person_mostRecentEligibilityDeterminations = (
  deserialized: Inbounds_inbounds_person_mostRecentEligibilityDeterminations
): Inbounds_inbounds_person_mostRecentEligibilityDeterminationsOrig => ({
  ...deserialized,
  month:
    deserialized.month != null
      ? formatISODate(deserialized.month)
      : deserialized.month,
  createdAt: formatISO(deserialized.createdAt),
  additionalData:
    deserialized.additionalData != null
      ? serializeAdditionalData(deserialized.additionalData)
      : deserialized.additionalData,
})
export interface Inbounds_inbounds_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  middleName: string | null
  lastName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  openApplications: Inbounds_inbounds_person_openApplications[]
  mostRecentEligibilityDeterminations: Inbounds_inbounds_person_mostRecentEligibilityDeterminations[]
}
export const deserializeInbounds_inbounds_person = (
  serialized: Inbounds_inbounds_personOrig
): Inbounds_inbounds_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  openApplications: serialized.openApplications.map(
    deserializeInbounds_inbounds_person_openApplications
  ),
  mostRecentEligibilityDeterminations: serialized.mostRecentEligibilityDeterminations.map(
    deserializeInbounds_inbounds_person_mostRecentEligibilityDeterminations
  ),
})
export const serializeInbounds_inbounds_person = (
  deserialized: Inbounds_inbounds_person
): Inbounds_inbounds_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  openApplications: deserialized.openApplications.map(
    serializeInbounds_inbounds_person_openApplications
  ),
  mostRecentEligibilityDeterminations: deserialized.mostRecentEligibilityDeterminations.map(
    serializeInbounds_inbounds_person_mostRecentEligibilityDeterminations
  ),
})
export interface Inbounds_inbounds_personFormData {
  __typename: 'InboundPersonFormData'
  firstName: string | null
  lastName: string | null
  dob: Date | null
  phoneNumber: string | null
}
export const deserializeInbounds_inbounds_personFormData = (
  serialized: Inbounds_inbounds_personFormDataOrig
): Inbounds_inbounds_personFormData => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
})
export const serializeInbounds_inbounds_personFormData = (
  deserialized: Inbounds_inbounds_personFormData
): Inbounds_inbounds_personFormDataOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
})
export interface Inbounds_inbounds_mostRecentNjmmisCheck {
  __typename: 'NjmmisCheck'
  id: string
  status: NjmmisCheckStatus
  medicaidId: string | null
  eligibleServices: string[] | null
}
export const deserializeInbounds_inbounds_mostRecentNjmmisCheck = (
  serialized: Inbounds_inbounds_mostRecentNjmmisCheckOrig
): Inbounds_inbounds_mostRecentNjmmisCheck => ({...serialized})
export const serializeInbounds_inbounds_mostRecentNjmmisCheck = (
  deserialized: Inbounds_inbounds_mostRecentNjmmisCheck
): Inbounds_inbounds_mostRecentNjmmisCheckOrig => ({...deserialized})
export interface Inbounds_inbounds_account {
  __typename: 'Account'
  id: string
  department: string
  insuranceType: string
}
export const deserializeInbounds_inbounds_account = (
  serialized: Inbounds_inbounds_accountOrig
): Inbounds_inbounds_account => ({...serialized})
export const serializeInbounds_inbounds_account = (
  deserialized: Inbounds_inbounds_account
): Inbounds_inbounds_accountOrig => ({...deserialized})
export interface Inbounds_inbounds {
  __typename: 'Inbound'
  id: string
  reason: string
  dateOfService: Date | null
  serviceType: ServiceType | null
  createdAt: Date
  lastIntakeWebformReceivedAt: Date | null
  inboundType: InboundType
  insuranceOnDateOfService: InboundInsuranceOnDateOfService | null
  startedBy: Inbounds_inbounds_startedBy | null
  startedAt: Date | null
  completedBy: Inbounds_inbounds_completedBy | null
  completedAt: Date | null
  person: Inbounds_inbounds_person | null
  personFormData: Inbounds_inbounds_personFormData | null
  mostRecentNjmmisCheck: Inbounds_inbounds_mostRecentNjmmisCheck | null
  account: Inbounds_inbounds_account | null
}
export const deserializeInbounds_inbounds = (
  serialized: Inbounds_inboundsOrig
): Inbounds_inbounds => ({
  ...serialized,
  dateOfService:
    serialized.dateOfService != null
      ? parseDate(serialized.dateOfService)
      : serialized.dateOfService,
  createdAt: parseDate(serialized.createdAt),
  lastIntakeWebformReceivedAt:
    serialized.lastIntakeWebformReceivedAt != null
      ? parseDate(serialized.lastIntakeWebformReceivedAt)
      : serialized.lastIntakeWebformReceivedAt,
  startedBy:
    serialized.startedBy != null
      ? deserializeInbounds_inbounds_startedBy(serialized.startedBy)
      : serialized.startedBy,
  startedAt:
    serialized.startedAt != null
      ? parseDate(serialized.startedAt)
      : serialized.startedAt,
  completedBy:
    serialized.completedBy != null
      ? deserializeInbounds_inbounds_completedBy(serialized.completedBy)
      : serialized.completedBy,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
  person:
    serialized.person != null
      ? deserializeInbounds_inbounds_person(serialized.person)
      : serialized.person,
  personFormData:
    serialized.personFormData != null
      ? deserializeInbounds_inbounds_personFormData(serialized.personFormData)
      : serialized.personFormData,
  mostRecentNjmmisCheck:
    serialized.mostRecentNjmmisCheck != null
      ? deserializeInbounds_inbounds_mostRecentNjmmisCheck(
          serialized.mostRecentNjmmisCheck
        )
      : serialized.mostRecentNjmmisCheck,
  account:
    serialized.account != null
      ? deserializeInbounds_inbounds_account(serialized.account)
      : serialized.account,
})
export const serializeInbounds_inbounds = (
  deserialized: Inbounds_inbounds
): Inbounds_inboundsOrig => ({
  ...deserialized,
  dateOfService:
    deserialized.dateOfService != null
      ? formatISODate(deserialized.dateOfService)
      : deserialized.dateOfService,
  createdAt: formatISO(deserialized.createdAt),
  lastIntakeWebformReceivedAt:
    deserialized.lastIntakeWebformReceivedAt != null
      ? formatISO(deserialized.lastIntakeWebformReceivedAt)
      : deserialized.lastIntakeWebformReceivedAt,
  startedBy:
    deserialized.startedBy != null
      ? serializeInbounds_inbounds_startedBy(deserialized.startedBy)
      : deserialized.startedBy,
  startedAt:
    deserialized.startedAt != null
      ? formatISO(deserialized.startedAt)
      : deserialized.startedAt,
  completedBy:
    deserialized.completedBy != null
      ? serializeInbounds_inbounds_completedBy(deserialized.completedBy)
      : deserialized.completedBy,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
  person:
    deserialized.person != null
      ? serializeInbounds_inbounds_person(deserialized.person)
      : deserialized.person,
  personFormData:
    deserialized.personFormData != null
      ? serializeInbounds_inbounds_personFormData(deserialized.personFormData)
      : deserialized.personFormData,
  mostRecentNjmmisCheck:
    deserialized.mostRecentNjmmisCheck != null
      ? serializeInbounds_inbounds_mostRecentNjmmisCheck(
          deserialized.mostRecentNjmmisCheck
        )
      : deserialized.mostRecentNjmmisCheck,
  account:
    deserialized.account != null
      ? serializeInbounds_inbounds_account(deserialized.account)
      : deserialized.account,
})
export interface Inbounds {
  /**
   * List of inbounds
   */
  inbounds: Inbounds_inbounds[]
}
export const deserializeInbounds = (serialized: InboundsOrig): Inbounds => ({
  ...serialized,
  inbounds: serialized.inbounds.map(deserializeInbounds_inbounds),
})
export const serializeInbounds = (deserialized: Inbounds): InboundsOrig => ({
  ...deserialized,
  inbounds: deserialized.inbounds.map(serializeInbounds_inbounds),
})
export interface InboundsVariables {
  serviceType?: string[] | null
  dateOfService?: string[] | null
  intakeWebformReceived?: string[] | null
  startedById?: string[] | null
  inboundWebformId?: string[] | null
  openClosedStatus?: string | null
  inboundType?: string | null
  department?: string[] | null
  financialOffice?: string[] | null
  inboundReason?: string[] | null
  openApplications?: string[] | null
}
export const deserializeInboundsVariables = (
  serialized: InboundsVariablesOrig
): InboundsVariables => ({...serialized})
export const serializeInboundsVariables = (
  deserialized: InboundsVariables
): InboundsVariablesOrig => ({...deserialized})
